import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function PublicFooter() {
  const { t } = useTranslation();

  const links: { to: string; hash?: string; label: string }[] = [
    { to: "/about", label: t("footer.about") },
    { to: "/privacy", label: t("footer.privacy") },
    { to: "/pricing", label: t("footer.faq") },
  ];

  return (
    <footer className="border-t border-border/60">
      <div className="px-5 py-10">
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-1.5 text-center">
            <div className="flex items-center gap-2 text-sm font-semibold text-foreground">
              <span className="tracking-tight">VISIKT</span>
              <span className="text-muted-foreground">{t("footer.partOf")}</span>
              <a
                href="https://www.vikeep.no"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors underline-offset-4 hover:underline"
              >
                {t("footer.company")}
              </a>
            </div>
            <p className="text-xs text-muted-foreground">© 2026</p>
          </div>

          <nav
            aria-label="Footer"
            className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2"
          >
            {links.map((link) => (
              <Link
                key={`${link.to}${link.hash ?? ""}`}
                to={link.to}
                hash={link.hash}
                className="text-xs font-medium text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
